export default __webpack_public_path__ + "static/media/email.054d8cef.svg";